import React from "react";
import { Row, Col, Image, Container } from "react-bootstrap";
import EualHousingLogo from "../../assets/EqualHousingLogo.png";
import TopMortgageLogo from "../../assets/Top-Mortgage-Lender.png";
import Top100logo from "../../assets/Top-100-Logo 1.png";

import {
  StyledFooter,
  FooterBox,
  Imagefooter,
  TextBox,
  StandIn,
  FinePrint,
  Link,
  SocialIconBox,
  FooterNav,
  NavLink,
  NavText,
  CopyrightBar,
  CopyrightText,
  LuckBox,
  LuckLine,
  WishLuck,
} from "./styles";
import { SocialIcon, SocialPadding } from "../../layout/Rules/styles";

export const Footer = ({ year, luckAni }) => (
  <StyledFooter>
    <div style={{ width: "100%" }} id="luck">
      {luckAni ? (
        <LuckBox>
          <LuckLine></LuckLine>
          <WishLuck>Thanks for Participating</WishLuck>
          <LuckLine></LuckLine>
        </LuckBox>
      ) : (
        <StandIn></StandIn>
      )}
    </div>
    <FooterBox>
      <TextBox>
        <FinePrint style={{ textAlign: "center" }}>
          <strong>
            For licensing information, go to:{" "}
            <Link href="http://www.nmlsconsumeraccess.org/EntityDetails.aspx/company/3277" target="_blank">
              www.nmlsconsumeraccess.org.{" "}
            </Link>{" "}
            <br />Visit{" "}
            <Link target="_blank" href="https://www.swmc.com/disclaimer">
              https://www.swmc.com/disclaimer
            </Link>{" "}
            for the full list of license information.
          </strong>{" "}
          <br />Please{" "}
          <Link target="_blank" href="https://www.swmc.com/TXdis">
            Click Here
          </Link>{" "}
          to view Texas Complaint Notice and Servicing Disclosure.<br />
          Sun West Mortgage Company,Inc. is acting as the Lender and offers financing to qualified borrowers.
          TACA - a third party organization is not<br />affiliated with Sun West Mortgage Company,Inc.
          The name and logo of TACA are owned by TACA.
        </FinePrint>
      </TextBox>
      <Container>
      <Row className='pt-2 pb-5 d-flex justify-content-center text-center'>
        <Col xs={6} lg={2} md={2} xl={2} className='mb-2 d-xs-block d-md-none d-sm-none d-lg-none ' style={{ paddingTop: '20px' }}>
          <Imagefooter
            src={Top100logo}
            alt='Mortgage Executive Top 100 logo'
            title='Mortgage Executive Top 100 '
            style={{ height: '175px' }}
          />
        </Col>

        <Col xs={6} lg={2} md={2} xl={2} className='mb-2' style={{ paddingTop: '20px' }}>
          <a
            target='_blank'
            rel='noopener noreferrer'
            href='https://sunwestmortgage.com/'
            className='mb-3'>
            <Imagefooter
              src='https://resources.swmc.com/swmc-images/minified/Top-50-Logo-blue.png'
              alt='Mortgage Executive Top 50 logo'
              title='Mortgage Executive Top 50'
              style={{ height: '175px' }}
            />
          </a>
        </Col>
        {/* <Col xs={4} lg={2} md={2} xl={2} className='mb-2' style={{ paddingTop: '20px' }}>
          <Imagefooter
            src={TopMortgageLogo}
            alt='Top Mortgage Lender'
            title='Top Mortgage Lender '
            style={{ height: '175px' }}
          />
        </Col> */}
        <Col xs={6} lg={3} md={3} xl={2} className='mb-2' style={{ paddingTop: '20px' }}>
          <a
            target='_blank'
            rel='noopener noreferrer'
            href='https://www.bbb.org/us/ca/buena-park/profile/mortgage-banker/sun-west-mortgage-company-inc-1126-172020499'
            className='mb-2'>
            <Image
              src="https://resources.swmc.com/swmc-images/Footer/swmc/bbb.png"
              alt='BBB accredited business'
              style={{ height: '68px' }}
            />
          </a>
          <div style={{ paddingTop: '20px' }}>
            <a
              href='https://www.checkbca.org/report/sun-west-mortgage-company-inc-59000209'
              target='_blank'
              rel='noopener noreferrer'>
              <img
                src='https://resources.swmc.com/swmc-images/Footer/swmc/Bcawidgets.png'
                alt='Bca logo'
              />
            </a>
          </div>
        </Col>
        <Col xs={6} lg={3} md={3} xl={2} style={{ paddingTop: '20px' }}>
          <Image
            src={EualHousingLogo}
            alt='Equal Housing Opportunity'
            title='Equal Housing Opportunity logo'
            className='mb-3'
            style={{ height: '75px' }}
          />
          <div>
            <script
              type='text/javascript'
              src='https://birdeye.com/embed/v4/154834253370951/5/2709571098'></script>
            <div
              id='bf-revz-widget-2709571098'
              style={{
                textAlign: 'center',
                WebkitOverflowScrolling: 'touch',
              }}>
              <iframe
                name='bfiframe'
                src='https://birdeye.com/widget/render.php?bid=154834253370951&amp;wid=5&amp;ver=4&amp;update=0'
                id='bfpublish'
                scrolling='no'
                style={{
                  border: '1px solid transparent',
                  borderRadius: '8px',
                  display: 'block',
                  margin: '0px auto',
                  overflow: 'hidden',
                  width: '145px',
                  height: '75px',
                }}
                frameBorder='0'></iframe>
              <div
                className='bf-dv'
                style={{
                  fontFamily: '&quot;roboto&quot, sans-serif',
                  margin: '0px auto',
                  width: '145px',
                  color: 'rgb(102, 102, 102)',
                  backgroundColor: 'transparent',
                  display: ' table',
                  height: '25px',
                }}>
                <span
                  className='bf-spn'
                  style={{
                    fontSize: '12px',
                    lineHeight: '12px',
                    width: 'auto',
                    display: 'table-cell',
                    verticalAlign: 'middle',
                  }}>
                  powered by{' '}
                  <a
                    className='bf-pwr'
                    href='https://birdeye.com/?utm_source=development.swmc.com&amp;utm_medium=widget_review-badge&amp;utm_campaign=birdeye_widget&amp;utm_term=powered-by-birdeye&amp;utm_content=customer-reviews_rectangle_#51a8d3'
                    target='_blank'
                    rel='noopener noreferrer'
                    style={{
                      color: 'rgb(81, 168, 211)',
                      textDecoration: 'none',
                    }}>
                    BirdEye
                  </a>
                </span>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      </Container>
    </FooterBox>

    <FooterNav>
      <NavLink href="https://www.swmc.com/careers" target="_blank" side="left">
        <NavText>Careers</NavText>
      </NavLink>
      <NavLink href="https://www.swmc.com/contact-us" target="_blank">
        <NavText>Contact Us</NavText>
      </NavLink>
      <NavLink href="https://www.swmc.com/disclaimer" target="_blank">
        <NavText>Licenses</NavText>
      </NavLink>
      <NavLink href="https://www.swmc.com/loan-officer-search" target="_blank">
        <NavText>Originators</NavText>
      </NavLink>
      <NavLink
        href="https://www.swmc.com/financial-related-links"
        target="_blank"
      >
        <NavText>Financial Links</NavText>
      </NavLink>
      <NavLink href="https://www.swmc.com/swmc-site-map" target="_blank">
        <NavText>Site Map</NavText>
      </NavLink>
      <NavLink href="https://www.swmc.com/terms-and-conditions" target="_blank">
        <NavText> Terms & Conditions</NavText>
      </NavLink>
      <NavLink href="https://www.swmc.com/privacy-policy" target="_blank">
        <NavText>Privacy Policy</NavText>
      </NavLink>
      <NavLink
        href="https://www.swmc.com/borrower-concerns-complaints"
        target="_blank"
        side="right"
      >
        <NavText>Borrower Concerns and Complaints</NavText>
      </NavLink>
    </FooterNav>
    <CopyrightBar  style={{
                  paddingBottom: '70px'}}>
      <CopyrightText>
        © {year} Sun West Mortgage Company, Inc. All Rights Reserved
      </CopyrightText>
      <SocialIconBox>
        <SocialPadding
          href="https://www.facebook.com/SunWestMortgage/"
          target="_blank"
        >
          <SocialIcon src="https://resources.swmc.com/images/yourtruehome/facebook-symbol.svg" />
        </SocialPadding>
        <SocialPadding
          href="https://www.instagram.com/sunwestmortgage.inc/"
          target="_blank"
        >
          <SocialIcon src="https://resources.swmc.com/images/yourtruehome/instagram-symbol.svg" />
        </SocialPadding>
        <SocialPadding
          href="https://twitter.com/SunWestMortgage"
          target="_blank"
        >
          <SocialIcon src="https://resources.swmc.com/images/yourtruehome/twitter-symbol.svg" />
        </SocialPadding>
        <SocialPadding
          href="https://www.linkedin.com/company/sun-west-mortgage-company"
          target="_blank"
        >
          <SocialIcon src="https://resources.swmc.com/images/yourtruehome/linkedin-symbol.svg" />
        </SocialPadding>
      </SocialIconBox>
    </CopyrightBar>
  </StyledFooter>
);
